"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("./Box.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // Component


var Box =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Box, _React$PureComponent);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, _getPrototypeOf(Box).apply(this, arguments));
  }

  _createClass(Box, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_Box.StyledBox, _extends({}, this.props, {
        ref: this.props.passedRef
      }), this.props.children);
    }
  }]);

  return Box;
}(_react.default.PureComponent);

exports.Box = Box;
Box.displayName = 'Box'; // Prop Types

Box.propTypes = {
  isSticky: _propTypes.default.bool,
  // backgroundColor
  backgroundColor: _propTypes.default.string,
  // extends from
  extendsFrom: _propTypes.default.string,
  // flex
  flex: _propTypes.default.string,
  polaroid: _propTypes.default.bool,
  // flex layout
  alignItems: _propTypes.default.string,
  alignItemsXs: _propTypes.default.string,
  alignItemsSm: _propTypes.default.string,
  alignItemsMd: _propTypes.default.string,
  alignItemsLg: _propTypes.default.string,
  alignItemsXl: _propTypes.default.string,
  justifyContent: _propTypes.default.string,
  justifyContentXs: _propTypes.default.string,
  justifyContentSm: _propTypes.default.string,
  justifyContentMd: _propTypes.default.string,
  justifyContentLg: _propTypes.default.string,
  justifyContentXl: _propTypes.default.string,
  // columns
  column: _propTypes.default.number,
  columnXs: _propTypes.default.number,
  columnSm: _propTypes.default.number,
  columnMd: _propTypes.default.number,
  columnLg: _propTypes.default.number,
  columnXl: _propTypes.default.number,
  // display
  display: _propTypes.default.string,
  displayXs: _propTypes.default.string,
  displaySm: _propTypes.default.string,
  displayMd: _propTypes.default.string,
  displayLg: _propTypes.default.string,
  displayXl: _propTypes.default.string,
  // flex flow
  flexFlow: _propTypes.default.string,
  flexFlowXs: _propTypes.default.string,
  flexFlowSm: _propTypes.default.string,
  flexFlowMd: _propTypes.default.string,
  flexFlowLg: _propTypes.default.string,
  flexFlowXl: _propTypes.default.string,
  // margin
  margin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMd: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXsY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginSmY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginMdY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginLgY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  marginXlY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  // padding
  padding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXs: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMd: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlTop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlRight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlBottom: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlLeft: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXsY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingSmY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingMdY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingLgY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paddingXlY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  // shadow
  shadowLevel: _propTypes.default.number,
  shadowLevelXs: _propTypes.default.number,
  shadowLevelSm: _propTypes.default.number,
  shadowLevelMd: _propTypes.default.number,
  shadowLevelLg: _propTypes.default.number,
  shadowLevelXl: _propTypes.default.number,
  ref: _propTypes.default.node
};
Box.defaultProps = {
  isSticky: false,
  // backgroundColor
  backgroundColor: undefined,
  // extends
  extendsFrom: undefined,
  // flex
  flex: undefined,
  // flex layout
  alignItems: undefined,
  alignItemsXs: undefined,
  alignItemsSm: undefined,
  alignItemsMd: undefined,
  alignItemsLg: undefined,
  alignItemsXl: undefined,
  justifyContent: undefined,
  justifyContentXs: undefined,
  justifyContentSm: undefined,
  justifyContentMd: undefined,
  justifyContentLg: undefined,
  justifyContentXl: undefined,
  // columns
  column: undefined,
  columnXs: undefined,
  columnSm: undefined,
  columnMd: undefined,
  columnLg: undefined,
  columnXl: undefined,
  // display
  display: 'block',
  displayXs: undefined,
  displaySm: undefined,
  displayMd: undefined,
  displayLg: undefined,
  displayXl: undefined,
  // flexFlow
  flexFlow: undefined,
  flexFlowXs: undefined,
  flexFlowSm: undefined,
  flexFlowMd: undefined,
  flexFlowLg: undefined,
  flexFlowXl: undefined,
  // margin
  margin: undefined,
  marginXs: undefined,
  marginSm: undefined,
  marginMd: undefined,
  marginLg: undefined,
  marginXl: undefined,
  marginTop: undefined,
  marginXsTop: undefined,
  marginSmTop: undefined,
  marginMdTop: undefined,
  marginLgTop: undefined,
  marginXlTop: undefined,
  marginRight: undefined,
  marginXsRight: undefined,
  marginSmRight: undefined,
  marginMdRight: undefined,
  marginLgRight: undefined,
  marginXlRight: undefined,
  marginBottom: undefined,
  marginXsBottom: undefined,
  marginSmBottom: undefined,
  marginMdBottom: undefined,
  marginLgBottom: undefined,
  marginXlBottom: undefined,
  marginLeft: undefined,
  marginXsLeft: undefined,
  marginSmLeft: undefined,
  marginMdLeft: undefined,
  marginLgLeft: undefined,
  marginXlLeft: undefined,
  marginX: undefined,
  marginXsX: undefined,
  marginSmX: undefined,
  marginMdX: undefined,
  marginLgX: undefined,
  marginXlX: undefined,
  marginY: undefined,
  marginXsY: undefined,
  marginSmY: undefined,
  marginMdY: undefined,
  marginLgY: undefined,
  marginXlY: undefined,
  // padding
  padding: undefined,
  paddingXs: undefined,
  paddingSm: undefined,
  paddingMd: undefined,
  paddingLg: undefined,
  paddingXl: undefined,
  paddingTop: undefined,
  paddingXsTop: undefined,
  paddingSmTop: undefined,
  paddingMdTop: undefined,
  paddingLgTop: undefined,
  paddingXlTop: undefined,
  paddingRight: undefined,
  paddingXsRight: undefined,
  paddingSmRight: undefined,
  paddingMdRight: undefined,
  paddingLgRight: undefined,
  paddingXlRight: undefined,
  paddingBottom: undefined,
  paddingXsBottom: undefined,
  paddingSmBottom: undefined,
  paddingMdBottom: undefined,
  paddingLgBottom: undefined,
  paddingXlBottom: undefined,
  paddingLeft: undefined,
  paddingXsLeft: undefined,
  paddingSmLeft: undefined,
  paddingMdLeft: undefined,
  paddingLgLeft: undefined,
  paddingXlLeft: undefined,
  paddingX: undefined,
  paddingXsX: undefined,
  paddingSmX: undefined,
  paddingMdX: undefined,
  paddingLgX: undefined,
  paddingXlX: undefined,
  paddingY: undefined,
  paddingXsY: undefined,
  paddingSmY: undefined,
  paddingMdY: undefined,
  paddingLgY: undefined,
  paddingXlY: undefined,
  // shadow
  shadowLevel: undefined,
  shadowLevelXs: undefined,
  shadowLevelSm: undefined,
  shadowLevelMd: undefined,
  shadowLevelLg: undefined,
  shadowLevelXl: undefined,
  ref: undefined
};